import { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

import { paths } from 'components/LeftHandLayout';
import SuspenseFallback from 'components/routers/RouteHandler/SuspenseFallback';
import SecurityLayout from 'pages/security/SecurityLayout';
import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';

const ServerProtection = lazy(() => import('pages/security/ServerProtection'));
const EndpointProtection = lazy(
	() => import('pages/security/EndpointProtection'),
);
const NotFound = lazy(() => import('pages/NotFound'));

const SECURITY_ROLES = [roles.PURCHASER, roles.TECHNICIAN];

const SecurityRouter = () => {
	return (
		<Switch>
			<Route exact path={[paths.endpointProtection, paths.serverProtection]}>
				<SecurityLayout>
					<Suspense fallback={<SuspenseFallback />}>
						<Switch>
							<RoleRestrictedRoute
								exact
								path={paths.endpointProtection}
								component={EndpointProtection}
								whitelistedRoles={SECURITY_ROLES}
							/>
							<RoleRestrictedRoute
								exact
								path={paths.serverProtection}
								component={ServerProtection}
								whitelistedRoles={SECURITY_ROLES}
							/>
						</Switch>
					</Suspense>
				</SecurityLayout>
			</Route>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default SecurityRouter;
